<template>
  <div :style="styleObject">
    <Editor :id="id" :init="editorInit" v-model="content"></Editor>
  </div>
</template>

<script>
require('tinymce-mention-sourcecodecap');
/* eslint-disable */
import { uploadImage } from '@/api/common';
import _ from 'lodash';
import tinymce from 'tinymce/tinymce';
import Editor from '@tinymce/tinymce-vue';
import 'tinymce/themes/mobile/theme';
import 'tinymce/icons/default/icons.min.js';
import 'tinymce/themes/silver/theme';
import 'tinymce/plugins/image'; // 插入上传图片插件
import 'tinymce/plugins/media'; // 插入视频插件
import 'tinymce/plugins/table'; // 插入表格插件
import 'tinymce/plugins/lists'; // 列表插件
import 'tinymce/plugins/wordcount'; // 字数统计插件
import 'tinymce/plugins/link';
import 'tinymce/plugins/paste';
export default {
  name: 'tinymce',
  components: { Editor },
  props: {
    id: {
      type: String,
      default: null
    },
    value: {
      type: String,
      default: null
    },
    members: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      styleObject: {
        width: 'auto',
        height: 'auto'
      },
      content: '',
      editorInit: {
        mentions: {
          source: []
        },
        selector: this.id,
        content_css: '/tinymce/skins/ui/oxide/skin.css',
        language_url: '/tinymce/zh_CN.js',
        language: 'zh_CN',
        skin_url: '/tinymce/skins/ui/oxide',
        height: 300,
        plugins: 'paste link lists image table wordcount mention ',
        contextmenu: '',
        body_class: 'editor_content',
        paste_data_images: true,
        // toolbar:
        //   'link lineheight forecolor backcolor bold italic underline strikethrough | alignleft aligncenter alignright alignjustify | quicklink h2 h3 blockquote table numlist bullist preview fullscreen',
        toolbar: 'numlist bullist | bold italic image link',
        fontsize_formats: '14px',
        // 此处为图片上传处理函数
        images_upload_handler: (blobInfo, success, failure) => {
          this.handleImgUpload(blobInfo, success, failure);
        },
        auto_focus: true, // 自动获取焦点
        statusbar: false, // 底部的状态栏
        menubar: false, // 最上方的菜单
        branding: false, // 水印“Powered by TinyMCE”
        entity_encoding: 'raw'
      }
    };
  },
  methods: {
    // 图片上传
    handleImgUpload(blobInfo, success, failure) {
      // const imgBase64 = `data:${blobInfo.blob().type};base64,${blobInfo.base64()}`
      const fileData = blobInfo.blob();
      var data = new FormData();
      data.append('file', fileData);
      data.append('companyId', 292);
      data.append('fileTypeId', 19);
      uploadImage(data)
        .then(res => {
          // 传入success回调里的数据就是富文本编辑器里插入图片的src的值
          success(`${res.data}`);
        })
        .catch(() => {
          failure('error');
        });
    },
    initTinymce() {
      this.content = this.value;
      this.editorInit.mentions.source = this.members.map(item => {
        return {
          name: item.nickname
        };
      });
      tinymce.init(this.editorInit);
    },
    getContent() {
      let activeEditor;
      activeEditor = tinymce.editors.find(_ => _.id === this.id);
      var editBody = activeEditor.getBody();
      activeEditor.selection.select(editBody);
      const content = activeEditor.selection.getContent({ format: 'html' }).replace(/h\d/g, 'p');
      return content;
    }
  },
  mounted() {
    this.initTinymce();
  }
};
</script>
<style lang="less">
.atwho-li img {
  height: 20px;
}
.rte-autocomplete {
  position: absolute;
  top: 0px;
  left: 0px;
  display: block;
  z-index: 1000;
  float: left;
  min-width: 100px;
  margin: 2px 0 0;
  list-style: none;
  background-color: #fff;
  border-radius: 2px;
  box-shadow: 0 0px 2px rgba(0, 0, 0, 0.2);
  background-clip: padding-box;
  font-family: 'Helvetica Neue', Helvetica, Arial, sans-serif;
  font-size: 14px;
}

.rte-autocomplete > li.loading {
  height: 16px;
}

.rte-autocomplete > li > a {
  display: block;
  padding: 3px 10px;
  clear: both;
  font-weight: normal;
  line-height: 20px;
  color: #333;
  white-space: nowrap;
  text-decoration: none;
}

.rte-autocomplete > .active > a,
.rte-autocomplete > .active > a:hover,
.rte-autocomplete > .active > a:focus {
  background-color: rgb(225, 245, 255);
}
</style>
